import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createSlots as _createSlots, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex h-100 flex-column" }
const _hoisted_2 = { class: "side-menu-inner flex-fill overflow-auto" }
const _hoisted_3 = { class: "mb-2" }

import {computed, provide} from 'vue';
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import OperatorApplicationForwardButton
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/OperatorApplicationForwardButton.vue";
import AdditionalClientInfoDialog
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/AdditionalClientInfoDialog.vue";
import {__} from "~/ts/library/Translate";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import CreateNotificationDialog
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/CreateNotificationDialog.vue";
import ClientInfo
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/info/ClientInfo.vue";
import OperatorApplicationExportDialog
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/OperatorApplicationExportDialog.vue";
import OperatorApplicationSendToSupportDialog
    from "~/operatorApplication/vue/dialogs/dialog/topmenu/OperatorApplicationSendToSupportDialog.vue";
import PopoverMenuItem from "~/core-ui/vue/ui/popover-menu/PopoverMenuItem.vue";
import PopoverMenu from "~/core-ui/vue/ui/popover-menu/PopoverMenu.vue";
import OperatorApplicationTempBanDialog
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/OperatorApplicationTempBanDialog.vue";
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import ElConfirm from "~/core-ui/vue/ui/ElConfirm";
import OperatorApplicationExportPayloadDialogInterface
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/OperatorApplicationExportDialogInterface";
import {BigIconFlexButtonExposeInterface} from "~/cabinet/vue/interface/button/Interface";
import markClientAsUnreaded from "~/operatorApplication/ts/service/buddyList/markClientAsUnreaded";
import ForwardToOperatorEventInterface
    from "~/operatorApplication/vue/dialogs/dialog/topmenu/ForwardToOperatorEventInterface";
import OperatorApplicationMarkClientAsHaveNoAnswerDialog
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/OperatorApplicationMarkClientAsHaveNoAnswerDialog.vue";
import ClientDataProviderInfo
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/dataProvider/ClientDataProviderInfo.vue";
import OperatorApplicationBuddyList from "~/operatorApplication/ts/service/OperatorApplicationBuddyList";
import SideMenuClientMultiContacts
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/info/multiContacts/SideMenuClientMultiContacts.vue";
import SideMenuButtons from "~/operatorApplication/vue/dialogs/dialog/sidemenu/info/SideMenuButtons.vue";
import ClientSiteVisits from "~/operatorApplication/vue/dialogs/dialog/sidemenu/info/ClientSiteVisits.vue";
import SideMenuButton from "~/operatorApplication/vue/dialogs/dialog/sidemenu/info/SideMenuButton.vue";
import {
    TelephonyCallInjectionKey,
    TelephonyCallInjectionKeyInterface
} from "~/operatorApplication/vue/dialogs/dialog/sidemenu/info/fields/TelephonyCallInjectionKey";
import DateHelper from "~/ts/library/Date";
import getOperatorGroupsForForward
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/info/getOperatorGroupsForForward";
import ClientAnalyticCounters from "~/operatorApplication/vue/dialogs/dialog/sidemenu/info/ClientAnalyticCounters.vue";
import CoreUiAvatar from "~/core-ui/vue/chat/CoreUiAvatar.vue";
import SideMenuClientFields
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/info/SideMenuClientFields.vue";
import LcabApiRequestFactory from "~/cabinet/ts/api/LcabApiRequestFactory";
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";
import getLastClientDialogStatus from "~/operatorApplication/ts/data/getLastClientDialogStatus";
import StartCrossOperatorConversationButton
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/crossOperatorConversation/StartCrossOperatorConversationButton.vue";



import {defineComponent, ref} from 'vue';

const __default__ = defineComponent({
    name: "SideMenuInfoTab"
});

let showAllButtonsCommon = ref(false);

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    userdata: {},
    buddyList: {},
    selectedMessagesAsText: {},
    onMessageTagClick: { type: Function }
  },
  emits: ["forward", "toggle-ban", "toggle-cobrowse", "toggle-mute", "export-dialog", "emit-custom-event"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

let isCabinetIframe = OperatorAccountStore.isCabinetIframe;

let showAllButtons = showAllButtonsCommon;


let forwardButton = ref<BigIconFlexButtonExposeInterface>();
let buttonMinWidth = ref('7em');
let infoDialog = ref(false);
let notificationDialog = ref(false);
let exportDialog = ref(false);
let sendToSupportDialog = ref(false);
let tempBanDialog = ref(false);

let site = computed(() => {
    return OperatorAccountStore.sitesDictionary.value[props.userdata.siteId];
});

let canSendMessages = computed(() => OperatorAccountStore.data.value.accessRights.canSendMessages);


async function sendToCrm() {
    if (!showFreeDialogForSite()) {
        try {
            await ElConfirm(__("Вы уверены, что хотите выгрузить этот чат в CRM?"));
            let p: OperatorApplicationApi.OperatorBuddySendToCrmOpenApiModel = {
                username: props.userdata.username
            };
            await (new OperatorApiRequest({
                url: "/buddyList/sendToCrm",
                p
            })).save();
        } catch (e) {

        }
    }
}


function onMultiContactClick(client: OperatorApplicationApi.OperatorApplicationClientOpenApiModel) {
    if (client.username != props.userdata.username) {
        let cabinetDialog = OperatorAccountStore.cabinetClientDialog.value;
        if (cabinetDialog) {
            cabinetDialog.username = client.username;
        } else {
            OperatorApplicationBuddyList.addClientAndOpenByUsername(client.username);
        }
    }
}

function showFreeDialogForSite(): boolean {
    return OperatorAccountStore.showFreeDialogForSite(site.value.id);
}

function showNotificationDialog() {
    if (!showFreeDialogForSite()) {
        notificationDialog.value = true;
    }
}

function showInfoDialog() {
    if (!showFreeDialogForSite()) {
        infoDialog.value = true;
    }
}

function forwardUser(payload: ForwardToOperatorEventInterface) {
    if (forwardButton.value) {
        forwardButton.value.closePopover();
    }
    if (!showFreeDialogForSite()) {
        emits('forward', payload);
    }
}

let forwardGroups = computed(() => {
    return getOperatorGroupsForForward(site.value);
});

async function markAsUnreaded() {
    markClientAsUnreaded(props.userdata);
}

async function finishHaveNoAnswer() {
    let dialogId = props.userdata.lastDialog?.id;
    if (dialogId) {
        let p: OperatorApplicationApi.OperatorMessageSetDialogStatusOpenApiModel = {
            username: props.userdata.username,
            dialogId: dialogId,
            statusId: OperatorAccountStore.data.value.standartDialogStatusList.active
        };
        (await (new OperatorApiRequest({
            url: "/message/setDialogStatus",
            p
        })).send()).showMessageOnError();
    }
}

let canBan = computed(() => {
    return OperatorAccountStore.checkAccess(OperatorAccountStore.data.value.accessRights.canBan, props.userdata.siteId);
});

function getCustomEvents(forMenu: boolean) {
    return (site.value?.customEvents ?? []).filter(event => event.isDisplayInOperatorApplicationSideMenu == forMenu);
}

let customEventsForDropdown = computed(() => {
    return getCustomEvents(false);
});

let customEventsForButtons = computed(() => {
    return getCustomEvents(true);
});

let canCobrowse = computed(() => {
    return OperatorAccountStore.checkAccess(OperatorAccountStore.data.value.accessRights.canCobrowse, props.userdata.siteId);
});

let canExportChat = computed(() => {
    return OperatorAccountStore.checkAccess(OperatorAccountStore.data.value.accessRights.canExportChat, props.userdata.siteId);
});

let canEdit = computed(() => {
    return OperatorAccountStore.checkAccess(OperatorAccountStore.data.value.accessRights.canEditClientInfo, props.userdata.siteId);
});

let canViewReferer = computed(() => {
    return OperatorAccountStore.checkAccess(OperatorAccountStore.data.value.accessRights.canViewReferers, props.userdata.siteId);
});


let canViewVisitedPages = computed(() => {
    return OperatorAccountStore.checkAccess(OperatorAccountStore.data.value.accessRights.canViewSitePageOfClient, props.userdata.siteId);
});

function onBanButtonClick() {
    if (props.userdata.isBanned) {
        emits('toggle-ban', null);
    }
}


let markAsOfflineDialog = ref<{
    visible: boolean,
    client: OperatorApplicationApi.OperatorApplicationClientOpenApiModel
}>();

function openMarkAsOfflineDialog() {
    markAsOfflineDialog.value = {
        visible: true,
        client: props.userdata
    };
}


async function removeTargetReason(p: OperatorApplicationApi.RemoveTargetClientReasonOpenApiModel) {
    let result = await ((new OperatorApiRequest({
        url: "/buddyList/removeTargetClientReason",
        p,
        silent: true
    }))).send();
    result.showMessageOnError();
}

let telephonyCallAuthList = computed(() => {
    return site.value?.integrations.filter(integration => integration.telephonyPlatformData?.isCallAvailable) ?? [];
});

function getUrlForOpenInApplication(operatorId: string) {
    return `/cabinet/api/online/openOperatorApplication/${encodeURIComponent(operatorId)}/${encodeURIComponent(props.userdata.username)}`;
}

provide(TelephonyCallInjectionKey, computed<TelephonyCallInjectionKeyInterface>(() => ({
    telephonyCallAuthList: telephonyCallAuthList.value,
    integrationPlatformDictionary: OperatorAccountStore.integrationPlatformDictionary.value,
    makeCall: async (phone: string, auth: OperatorApplicationApi.OperatorGetParamsIntegrationAuthOpenApiModel) => {
        try {
            await ElConfirm(__(`Вы уверены, что хотите позвонить на номер %1$s через %2$s?`, phone, auth.descr));
            let p: OperatorApplicationApi.OperatorBuddyListMakeTelephonyCallOpenApiModel = {
                username: props.userdata.username,
                phone: phone,
                authPrimaryId: auth.authPrimaryId,
                platformId: auth.platformId
            };
            await (new OperatorApiRequest<OperatorApplicationApi.OperatorSyncBuddyListResultOpenApiModel>({
                url: "/buddyList/makeTelephonyCallMethod",
                p
            })).save();
        } catch (e) {

        }
    }
})));

function openExternal(url: string) {
    window.open(url);
}

let canDeleteChat = computed(() => {
    return !!OperatorAccountStore.cabinetClientDialog.value?.checkAccessForOnlineRemoveDialogs;
});

async function deleteChat() {
    try {
        await ElConfirm("Вы уверены, что хотите удалить этот чат? Эта операция необратима");
        let result = await LcabApiRequestFactory.create({
            url: `/api/online/reports/client/${props.userdata.username}/deleteChat`
        }).save();
        if (result.isSuccess) {
            ClientUserdataStore.reload();
        }
    } catch (e) {
    }
}

let dialogStatus = computed(() => getLastClientDialogStatus(props.userdata));



return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SideMenuClientMultiContacts, {
        site: _unref(site),
        userdata: __props.userdata,
        onClick: onMultiContactClick
      }, null, 8, ["site", "userdata"]),
      (_openBlock(), _createBlock(SideMenuClientFields, {
        key: __props.userdata.username,
        userdata: __props.userdata,
        site: _unref(site),
        readonly: !_unref(canEdit),
        "on-message-tag-click": _unref(props).onMessageTagClick,
        "hide-not-filled-client-fields-enabled": _unref(OperatorApplicationConfigInstance).hideNotFilledClientFieldsEnabled
      }, null, 8, ["userdata", "site", "readonly", "on-message-tag-click", "hide-not-filled-client-fields-enabled"])),
      _createVNode(ClientDataProviderInfo, {
        userdata: __props.userdata,
        site: _unref(site)
      }, null, 8, ["userdata", "site"]),
      _createVNode(ClientInfo, {
        userdata: __props.userdata,
        site: _unref(site),
        "location-language": _unref(OperatorApplicationConfigInstance).language.locationDescr,
        "ip-info-url": _unref(OperatorApplicationConfigInstance).ipInfoUrl,
        "static-server": _unref(OperatorApplicationConfigInstance).staticServer,
        "integration-platform-dictionary": _unref(OperatorAccountStore).integrationPlatformDictionary.value,
        "client-devices": _unref(OperatorAccountStore).data.value.clientDevices,
        "can-edit": _unref(canEdit),
        "remove-target-reason": removeTargetReason
      }, null, 8, ["userdata", "site", "location-language", "ip-info-url", "static-server", "integration-platform-dictionary", "client-devices", "can-edit"]),
      (!__props.userdata.integration)
        ? (_openBlock(), _createBlock(ClientSiteVisits, {
            key: 0,
            userdata: __props.userdata,
            site: _unref(site),
            "can-view-referer": _unref(canViewReferer),
            "can-view-site-page-of-client": _unref(canViewVisitedPages)
          }, null, 8, ["userdata", "site", "can-view-referer", "can-view-site-page-of-client"]))
        : _createCommentVNode("", true),
      _createVNode(ClientAnalyticCounters, {
        userdata: __props.userdata,
        site: _unref(site)
      }, null, 8, ["userdata", "site"])
    ]),
    _createVNode(SideMenuButtons, {
      "with-shadow": "",
      class: _normalizeClass({
                'buttons': true,
                'show-all-buttons': _unref(showAllButtons)
            })
    }, _createSlots({
      default: _withCtx(() => [
        (!_unref(isCabinetIframe))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_unref(dialogStatus)?.isHaveNoAnswer && _unref(canSendMessages))
                ? (_openBlock(), _createBlock(SideMenuButton, {
                    key: 0,
                    icon: "question-square",
                    descr: _unref(__)('Завершить Offline вопрос'),
                    "min-width": _unref(buttonMinWidth),
                    onClick: finishHaveNoAnswer
                  }, null, 8, ["descr", "min-width"]))
                : _createCommentVNode("", true),
              (_unref(forwardGroups).length && _unref(canSendMessages))
                ? (_openBlock(), _createBlock(SideMenuButton, {
                    key: 1,
                    icon: "share",
                    descr: _unref(__)('Переключить'),
                    "min-width": _unref(buttonMinWidth),
                    "popper-class": "p-0",
                    "popover-placement": "top",
                    ref_key: "forwardButton",
                    ref: forwardButton
                  }, {
                    popover: _withCtx(() => [
                      _createVNode(OperatorApplicationForwardButton, {
                        site: _unref(site),
                        groups: _unref(forwardGroups),
                        "group-selectable": "",
                        onForward: _cache[1] || (_cache[1] = ($event: any) => (forwardUser($event)))
                      }, null, 8, ["site", "groups"])
                    ]),
                    _: 1
                  }, 8, ["descr", "min-width"]))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_unref(OperatorAccountStore).getOperatorsOfSite(_unref(site)).length)
                ? (_openBlock(), _createBlock(SideMenuButton, {
                    key: 0,
                    icon: "user-headset",
                    descr: "В приложение оператора",
                    "min-width": _unref(buttonMinWidth),
                    "popper-class": "p-0",
                    "popover-placement": "top"
                  }, {
                    popover: _withCtx(() => [
                      _createVNode(_component_el_scrollbar, null, {
                        default: _withCtx(() => [
                          _createVNode(PopoverMenu, null, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(OperatorAccountStore).getOperatorsOfSite(_unref(site)), (operator) => {
                                return (_openBlock(), _createBlock(PopoverMenuItem, {
                                  key: operator.id,
                                  onClick: ($event: any) => (openExternal(getUrlForOpenInApplication(operator.id)))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(CoreUiAvatar, {
                                      src: operator.avatar,
                                      size: "1.5em",
                                      class: "mr-1"
                                    }, null, 8, ["src"]),
                                    _createTextVNode(" " + _toDisplayString(operator.fio) + " (" + _toDisplayString(operator.login) + ") ", 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["min-width"]))
                : _createCommentVNode("", true)
            ], 64)),
        (!__props.userdata.integration)
          ? (_openBlock(), _createBlock(SideMenuButton, {
              key: 2,
              icon: "info-square",
              descr: _unref(__)('Страницы'),
              "min-width": _unref(buttonMinWidth),
              onClick: showInfoDialog
            }, null, 8, ["descr", "min-width"]))
          : _createCommentVNode("", true),
        (!__props.userdata.integration && _unref(canCobrowse))
          ? (_openBlock(), _createBlock(SideMenuButton, {
              key: 3,
              icon: "life-ring",
              descr: "Co-Browse",
              "min-width": _unref(buttonMinWidth),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(emits)('toggle-cobrowse')))
            }, null, 8, ["min-width"]))
          : _createCommentVNode("", true),
        (!_unref(isCabinetIframe))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              _createVNode(SideMenuButton, {
                icon: "bell",
                descr: _unref(__)('Напоминание'),
                "min-width": _unref(buttonMinWidth),
                onClick: showNotificationDialog
              }, null, 8, ["descr", "min-width"]),
              _createVNode(StartCrossOperatorConversationButton, {
                userdata: __props.userdata,
                "button-min-width": _unref(buttonMinWidth)
              }, null, 8, ["userdata", "button-min-width"])
            ], 64))
          : _createCommentVNode("", true),
        (_unref(canBan))
          ? (_openBlock(), _createBlock(SideMenuButton, {
              key: 5,
              icon: __props.userdata.isBanned ? 'user-check' : 'ban',
              descr: __props.userdata.isBanned ? _unref(__)('Разбанить') :_unref(__)('Забанить'),
              "min-width": _unref(buttonMinWidth),
              "popper-class": "p-0",
              "popover-placement": "top",
              onClick: onBanButtonClick
            }, _createSlots({ _: 2 }, [
              (!__props.userdata.isBanned)
                ? {
                    name: "popover",
                    fn: _withCtx(() => [
                      _createVNode(PopoverMenu, null, {
                        default: _withCtx(() => [
                          _createVNode(PopoverMenuItem, {
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(emits)('toggle-ban', null)))
                          }, {
                            default: _withCtx(() => [
                              (_unref(site).clientBanTTL)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(_unref(__)("Забанить на %s", _unref(DateHelper).secondsFormat(_unref(site).clientBanTTL))), 1)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString(_unref(__)("Забанить навсегда")), 1)
                                  ], 64))
                            ]),
                            _: 1
                          }),
                          _createVNode(PopoverMenuItem, {
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_isRef(tempBanDialog) //@ts-ignore
 ? tempBanDialog.value = true : tempBanDialog = true))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(__)("Забанить на время")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["icon", "descr", "min-width"]))
          : _createCommentVNode("", true),
        (_unref(canExportChat))
          ? (_openBlock(), _createBlock(SideMenuButton, {
              key: 6,
              icon: "download",
              descr: _unref(__)('Выгрузить чат'),
              "min-width": _unref(buttonMinWidth),
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_isRef(exportDialog) //@ts-ignore
 ? exportDialog.value = true : exportDialog = true))
            }, null, 8, ["descr", "min-width"]))
          : _createCommentVNode("", true),
        (_unref(isCabinetIframe))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
              (_unref(canDeleteChat))
                ? (_openBlock(), _createBlock(SideMenuButton, {
                    key: 0,
                    icon: "trash",
                    descr: "Удалить чат",
                    "min-width": _unref(buttonMinWidth),
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (deleteChat()))
                  }, null, 8, ["min-width"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (_unref(site).crm.isManualExportAvailable)
          ? (_openBlock(), _createBlock(SideMenuButton, {
              key: 8,
              icon: "file-export",
              descr: _unref(__)('Выгрузить в CRM'),
              "min-width": _unref(buttonMinWidth),
              onClick: sendToCrm
            }, null, 8, ["descr", "min-width"]))
          : _createCommentVNode("", true),
        (!_unref(isCabinetIframe))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
              _createVNode(SideMenuButton, {
                icon: "circle",
                descr: _unref(__)('Пометить непрочитанным'),
                onClick: markAsUnreaded,
                "min-width": _unref(buttonMinWidth)
              }, null, 8, ["descr", "min-width"]),
              (!_unref(dialogStatus)?.isHaveNoAnswer)
                ? (_openBlock(), _createBlock(SideMenuButton, {
                    key: 0,
                    icon: "question-square",
                    descr: _unref(__)('Пометить как Offline'),
                    "min-width": _unref(buttonMinWidth),
                    onClick: openMarkAsOfflineDialog
                  }, null, 8, ["descr", "min-width"]))
                : _createCommentVNode("", true),
              (_unref(OperatorAccountStore).checkAccess(_unref(OperatorAccountStore).data.value.accessRights.canToggleMute, __props.userdata.siteId))
                ? (_openBlock(), _createBlock(SideMenuButton, {
                    key: 1,
                    icon: __props.userdata.isMuted ? 'volume' : 'volume-mute',
                    descr: __props.userdata.isMuted ? _unref(__)('Включить уведомления') :_unref(__)('Отключить уведомления'),
                    "min-width": _unref(buttonMinWidth),
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(emits)('toggle-mute')))
                  }, null, 8, ["icon", "descr", "min-width"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (__props.userdata.ocode)
          ? (_openBlock(), _createBlock(SideMenuButton, {
              key: 10,
              icon: "question-circle",
              descr: "Отправить в ТП",
              "min-width": _unref(buttonMinWidth),
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_isRef(sendToSupportDialog) //@ts-ignore
 ? sendToSupportDialog.value = true : sendToSupportDialog = true))
            }, null, 8, ["min-width"]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(customEventsForButtons), (event) => {
          return (_openBlock(), _createBlock(SideMenuButton, {
            key: event.id,
            descr: event.descr,
            "min-width": _unref(buttonMinWidth),
            onClick: ($event: any) => (_unref(emits)('emit-custom-event', event.id))
          }, null, 8, ["descr", "min-width", "onClick"]))
        }), 128)),
        (_unref(customEventsForDropdown).length > 0)
          ? (_openBlock(), _createBlock(SideMenuButton, {
              key: 11,
              icon: 'bullhorn',
              descr: _unref(__)('Запустить своё событие'),
              "min-width": _unref(buttonMinWidth),
              "popper-class": "p-0",
              "popover-placement": "top"
            }, {
              popover: _withCtx(() => [
                _createVNode(PopoverMenu, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(customEventsForDropdown), (event) => {
                      return (_openBlock(), _createBlock(PopoverMenuItem, {
                        key: event.id,
                        onClick: ($event: any) => (_unref(emits)('emit-custom-event', event.id))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(event.descr), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["descr", "min-width"]))
          : _createCommentVNode("", true),
        _createVNode(SideMenuButton, {
          class: "more",
          icon: "ellipsis-h",
          descr: _unref(__)('Ещё'),
          "min-width": _unref(buttonMinWidth),
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_isRef(showAllButtons) //@ts-ignore
 ? showAllButtons.value = true : showAllButtons = true))
        }, null, 8, ["descr", "min-width"])
      ]),
      _: 2
    }, [
      (_unref(showAllButtons))
        ? {
            name: "before",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_el_button, {
                  class: "d-block hide-all-buttons-button w-100 text-center",
                  link: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(showAllButtons) //@ts-ignore
 ? showAllButtons.value = false : showAllButtons = false))
                }, {
                  default: _withCtx(() => [
                    _createVNode(FontAwesomeIcon, {
                      class: "mr-1 ml-1 d-inline-block",
                      icon: "chevron-double-down"
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["class"]),
    _createVNode(CreateNotificationDialog, {
      visible: _unref(notificationDialog),
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => (_isRef(notificationDialog) ? (notificationDialog).value = $event : notificationDialog = $event)),
      userdata: __props.userdata,
      site: _unref(site)
    }, null, 8, ["visible", "userdata", "site"]),
    (_unref(infoDialog))
      ? (_openBlock(), _createBlock(AdditionalClientInfoDialog, {
          key: 0,
          userdata: __props.userdata,
          visible: _unref(infoDialog),
          "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => (_isRef(infoDialog) ? (infoDialog).value = $event : infoDialog = $event))
        }, null, 8, ["userdata", "visible"]))
      : _createCommentVNode("", true),
    _createVNode(OperatorApplicationExportDialog, {
      visible: _unref(exportDialog),
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => (_isRef(exportDialog) ? (exportDialog).value = $event : exportDialog = $event)),
      onSend: _cache[13] || (_cache[13] = ($event: any) => (_unref(emits)('export-dialog', $event)))
    }, null, 8, ["visible"]),
    (_unref(sendToSupportDialog))
      ? (_openBlock(), _createBlock(OperatorApplicationSendToSupportDialog, {
          key: 1,
          visible: _unref(sendToSupportDialog),
          "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => (_isRef(sendToSupportDialog) ? (sendToSupportDialog).value = $event : sendToSupportDialog = $event)),
          userdata: __props.userdata,
          "selected-messages": __props.selectedMessagesAsText
        }, null, 8, ["visible", "userdata", "selected-messages"]))
      : _createCommentVNode("", true),
    (_unref(tempBanDialog))
      ? (_openBlock(), _createBlock(OperatorApplicationTempBanDialog, {
          key: 2,
          visible: _unref(tempBanDialog),
          "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => (_isRef(tempBanDialog) ? (tempBanDialog).value = $event : tempBanDialog = $event)),
          onInput: _cache[16] || (_cache[16] = ($event: any) => (_unref(emits)('toggle-ban', $event)))
        }, null, 8, ["visible"]))
      : _createCommentVNode("", true),
    (_unref(markAsOfflineDialog) && _unref(markAsOfflineDialog).visible)
      ? (_openBlock(), _createBlock(OperatorApplicationMarkClientAsHaveNoAnswerDialog, {
          key: 3,
          userdata: _unref(markAsOfflineDialog).client,
          visible: _unref(markAsOfflineDialog).visible,
          "onUpdate:visible": _cache[17] || (_cache[17] = ($event: any) => ((_unref(markAsOfflineDialog).visible) = $event))
        }, null, 8, ["userdata", "visible"]))
      : _createCommentVNode("", true)
  ]))
}
}

})